import { useNavigate, useParams } from 'react-router-dom'
import {
  FBPageHeader,
  FBPageInnerTabsContainer,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { Tabs } from '../../../components/FbUI/Tabs'
import { useNavbarStore } from '../../../components/Layout/navbar-store'
import { ChevronLeft } from 'lucide-react'
import useApiService from '../../../services/api'
import { FBPage } from 'components/FbUI/Page/FBPage'
import { RebateOfferDetailsTab } from 'features/tradespend/RebateOfferDetailsTab'
import { RebateOfferEnrollmentsTab } from 'features/tradespend/enrollments/RebateOfferEnrollmentsTab'
import { RebateOfferAttributionTab } from 'features/tradespend/RebateOfferAttributionTab'

const TABLE_CONTAINER_HEIGHT = 'calc(var(--base-page-table-height) - 95px)'

const defaultEnrollmentsColumnVisibility = {
  tradespend_user_name: true,
  company_name: true,
  attribution_code: true,
  status: true,
  created: true,
}

const defaultAttributionColumnVisibility = {
  name: true,
  description: true,
  code: true,
  url: true,
  view_count: true,
  created_by: true,
  created: true,
}

export function RebateOfferDetails() {
  const navigate = useNavigate()
  const params = useParams()
  const selectedTab = params?.tab ?? 'details'
  const store = useNavbarStore()
  const api = useApiService()

  const { data: offer, isLoading } = api.useGetRebateOffer(
    Number(params.offerId)
  )

  const tabs = [
    { key: 'details', title: 'Details' },
    { key: 'enrollments', title: 'Engagement' },
    { key: 'attribution', title: 'Attribution Codes' },
  ]

  return (
    <FBPage>
      <FBPageHeader>
        <FBPageTitleRow>
          <div className="flex flex-col gap-4">
            <button
              type="button"
              onClick={() => {
                const url = '/rebates/offers'
                navigate(url)
                store.setLastRebateVisited(url)
              }}
              className="inline-flex w-fit items-center gap-1 text-sm font-medium text-neutral-500 transition-colors hover:text-neutral-700"
            >
              <ChevronLeft size={16} />
              Back to Rebates
            </button>
            <FBPageTitle>Offer: {offer?.name}</FBPageTitle>
          </div>
        </FBPageTitleRow>
      </FBPageHeader>

      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={(value) => {
            const url = `/rebates/offer/${params.offerId}/${value}/`
            navigate(url)
            store.setLastRebateVisited(url)
          }}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>

      {selectedTab === 'details' && (
        <RebateOfferDetailsTab offer={offer} isLoading={isLoading} />
      )}

      <FBPageTableContainer
        style={{ height: TABLE_CONTAINER_HEIGHT }}
        hide={selectedTab !== 'enrollments'}
      >
        <RebateOfferEnrollmentsTab
          offerId={Number(params.offerId)}
          tableKey={`rebate-offer-enrollments-table-${params.offerId}`}
          defaultColumnVisibility={defaultEnrollmentsColumnVisibility}
        />
      </FBPageTableContainer>

      <FBPageTableContainer
        style={{ height: TABLE_CONTAINER_HEIGHT }}
        hide={selectedTab !== 'attribution'}
      >
        <RebateOfferAttributionTab
          offerId={Number(params.offerId)}
          defaultColumnVisibility={defaultAttributionColumnVisibility}
        />
      </FBPageTableContainer>
    </FBPage>
  )
}
